export default {
  // FORBIDDEN
  'error.page.forbidden.message': 'Forbidden',
  'error.page.forbidden.back.to.homepage.button': 'Back to homepage',

  // NOT_FOUND
  'error.page.not.found.message': 'Page not found',
  'error.page.not.found.back.to.homepage.button': 'Back to homepage',
};
